import React from 'react';

import {
  CreateUserRequestDtoProfileEnum,
  CreateViolationDtoFormFieldEnum,
} from 'lib_api/lib/api/gen';

import { Select } from 'components/WrappedComponents';
import { FieldProps } from 'components/WrappedComponents/Form/FormWrapper/type';
import { useApi } from 'hooks/ApiStoreContext';
import { CreationCompteFormValues } from 'types/Compte/CreationCompte';
import { FormPlaceholders } from 'types/enums/FormPlaceholders';
import { CSSUtils } from 'utils/CSSUtils';

import {
  generateCreateUserRequestDtoFromFormData,
  validateCreateUserRequest,
} from '../utils';

interface SelectProfileProps extends FieldProps<CreationCompteFormValues> {
  disabled?: boolean;
}

function SelectProfile({
  values,
  disabled = false,
}: SelectProfileProps): React.ReactElement {
  const cuController = useApi().ComptesUtilisateursControllerApi;
  const key: keyof CreationCompteFormValues = 'profile';

  // list of options of select
  const selectItems = [
    {
      value: CreateUserRequestDtoProfileEnum.GARDIEN_FOURRIERE,
      displayValue: 'Gardien de fourrière',
    },
    {
      value: CreateUserRequestDtoProfileEnum.AUTORITE_FOURRIERE,
      displayValue: 'Autorité de fourrière',
    },
    {
      value: CreateUserRequestDtoProfileEnum.FORCE_DE_L_ORDRE,
      displayValue: "Force de l'Ordre",
    },
    {
      value: CreateUserRequestDtoProfileEnum.ADMIN_FONCTIONNEL,
      displayValue: 'Administrateur fonctionnel',
    },
    {
      value: CreateUserRequestDtoProfileEnum.DSR_BLR,
      displayValue: 'DSR',
    },
  ];

  return (
    <Select
      wrapperProps={{
        values: values,
        fieldKey: key,
        itemProps: {
          label: 'Profil à créer',
          rules: [
            {
              required: true,
              validator: async (
                _rule,
                value: CreateUserRequestDtoProfileEnum | undefined,
              ): Promise<void> => {
                const requestObject = generateCreateUserRequestDtoFromFormData({
                  ...values,
                  profile: value,
                });

                return await validateCreateUserRequest(
                  cuController,
                  requestObject,
                  CreateViolationDtoFormFieldEnum.PROFILE,
                );
              },
            },
          ],
          labelCol: { span: CSSUtils.defaultLabelCol },
          wrapperCol: { span: CSSUtils.largeWrapperCol },
        },
      }}
      optionProps={selectItems}
      selectProps={{
        disabled: disabled,
        placeholder: FormPlaceholders.Select,
        dropdownMatchSelectWidth: 350,
        suffixIcon: null,
        allowClear: true,
      }}
    />
  );
}

export default SelectProfile;
